module.exports = __webpack_public_path__ + "img/rjcStatement@2x.bc8e467.jpg";